import { gql } from 'graphql-tag'
import { seoFragment } from '../fragments/seo.js'

export const getModalitaDuso = gql`
  ${seoFragment}
  query GetModalitaDuso($slug: [String], $site: [String]) {
    modalitaDusoEntries(slug: $slug, site: $site) {
      ... on modalitaDuso_Entry {
        id
        title
        localized {
          slug
          language
        }
        seo {
          ...SeoFragment
        }
        sezioneContenutoPagina {
          ... on testo_Entry {
            text
          }
          ... on immagine_Entry {
            custom: immagine @transform(format: "webp", width: 1800) {
              id
              url
              width
              height
              title
            }
          }
          ... on immagineTradotta_Entry {
            custom: immagineTradotta @transform(format: "webp", width: 1800) {
              id
              url
              width
              height
              title
            }
          }
        }
      }
    }
  }
`
